import React, { useEffect, useState } from "react";
import axios from "axios";
import { storage } from "../../utils";
import { useDashboardRole } from "../../context/dashboardRole";
import { Redirect } from "react-router-dom";

async function authHeaders() {
  const token = await storage.load("token");
  return { "x-auth": token, "Content-Type": "application/json" };
}

const StaffManagement = () => {
  const { role, loading } = useDashboardRole();
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");
  const [msg, setMsg] = useState("");
  const [form, setForm] = useState({
    user_name: "",
    name: "",
    password: "",
    phone_number: "",
  });

  const load = async () => {
    try {
      const headers = await authHeaders();
      const res = await axios.get("/owner/staff", { headers });
      setRows(res.data.data || []);
      setErr("");
    } catch (e) {
      setErr(
        (e.response && e.response.data && e.response.data.message) ||
          "دسترسی مجاز نیست یا نشست منقضی شده است."
      );
    }
  };

  useEffect(() => {
    if (role === "owner") load();
  }, [role]);

  if (loading) return null;
  if (role !== "owner") return <Redirect to="/dashboard/access-denied" />;

  const create = async () => {
    setMsg("");
    try {
      const headers = await authHeaders();
      await axios.post("/owner/staff", form, { headers });
      setForm({ user_name: "", name: "", password: "", phone_number: "" });
      setMsg("حساب کارمند ایجاد شد.");
      load();
    } catch (_) {
      setErr("ایجاد حساب ناموفق بود.");
    }
  };

  const patchStatus = async (id, status) => {
    try {
      const headers = await authHeaders();
      await axios.patch(`/owner/staff/${id}`, { status }, { headers });
      load();
    } catch (e) {
      setErr(
        (e.response && e.response.data && e.response.data.message) ||
          "به‌روزرسانی ناموفق"
      );
    }
  };

  const revoke = async (id) => {
    const headers = await authHeaders();
    await axios.post(`/owner/staff/${id}/revoke_sessions`, {}, { headers });
    setMsg("نشست‌های کاربر باطل شد.");
  };

  const resetPassword = async (id) => {
    const password = window.prompt("رمز عبور جدید (حداقل ۱۰ کاراکتر):");
    if (!password) return;
    try {
      const headers = await authHeaders();
      await axios.post(
        `/owner/staff/${id}/reset_password`,
        { password },
        { headers }
      );
      setMsg("رمز عبور به‌روز و نشست‌ها باطل شد.");
    } catch (_) {
      setErr("بازنشانی رمز ناموفق بود.");
    }
  };

  return (
    <div className="puDashPage" dir="rtl">
      <h2>مدیریت دسترسی کارکنان</h2>
      <p style={{ color: "#555" }}>
        فقط مالک می‌تواند حساب کارمند بسازد، فعال/غیرفعال کند یا نشست‌ها را باطل
        کند.
      </p>
      {err ? <div style={{ color: "#c8102e" }}>{err}</div> : null}
      {msg ? <div style={{ color: "#0a7" }}>{msg}</div> : null}

      <div
        style={{
          marginTop: 16,
          marginBottom: 24,
          maxWidth: 480,
          display: "grid",
          gap: 8,
        }}
      >
        <h4>ایجاد حساب کارمند</h4>
        <input
          placeholder="نام کاربری"
          value={form.user_name}
          onChange={(e) => setForm({ ...form, user_name: e.target.value })}
        />
        <input
          placeholder="نام نمایشی"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
        <input
          type="password"
          placeholder="رمز عبور"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
        />
        <input
          placeholder="موبایل (اختیاری)"
          value={form.phone_number}
          onChange={(e) => setForm({ ...form, phone_number: e.target.value })}
        />
        <button type="button" className="btn btn-primary" onClick={create}>
          ایجاد
        </button>
      </div>

      <table className="table" style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>نام کاربری</th>
            <th>نقش</th>
            <th>وضعیت</th>
            <th>آخرین ورود</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((u) => (
            <tr key={u._id}>
              <td>{u.user_name}</td>
              <td>{u.role === "owner" ? "مالک" : "کارمند"}</td>
              <td>{u.status === "active" ? "فعال" : u.status}</td>
              <td>
                {u.last_login_at
                  ? new Date(u.last_login_at).toLocaleString("fa-IR")
                  : "—"}
              </td>
              <td style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {u.role === "staff" ? (
                  <>
                    {u.status === "active" ? (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => patchStatus(u._id, "disabled")}
                      >
                        غیرفعال
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-success"
                        onClick={() => patchStatus(u._id, "active")}
                      >
                        فعال
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => revoke(u._id)}
                    >
                      ابطال نشست‌ها
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-warning"
                      onClick={() => resetPassword(u._id)}
                    >
                      بازنشانی رمز
                    </button>
                  </>
                ) : (
                  <span style={{ color: "#888" }}>—</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export { StaffManagement };
